"use client"

import useCommonStore from '@/store/commonStore';
import { X } from 'lucide-react'
import { useRouter } from 'next/navigation';

export default function ProfileMobileMenu({
  navItems,
  setActiveTab,
  translations
}: {
  navItems: { label: string; key: string }[]
  setActiveTab: (key: string) => void
  translations:any
}) {
  const router = useRouter()
  const { logout,user } = useCommonStore()

  const handleTabClick = (key: string) => {
    setActiveTab(key)
    router.push(`/profile?tab=${key}`)
  }

  return (
    <div className="p-3">
      <div className="flex justify-between items-start mb-2">
        <button onClick={() => router.push("/")} aria-label="Close">
          <X className="w-7 h-7" />
        </button>
        <div className='absolute top-4 right-4 rtl:left-4 rtl:right-auto rtl:scale-x-[-1]'>
          <img src="https://curlified.com/assets/profile-img.2aa3d373.svg" alt="profile" className="w-30 h-30" />
        </div>
      </div>
      <h6 className="font-bold text-lg text-primary mb-1 mt-5">{user?.full_nm||user?.address?.full_nm}</h6>
      <p className="text-sm text-gray-700 mb-10"> <span dir='ltr'>{user?.phn_cd} {user?.phn_num}</span></p>
      <div className="flex flex-col gap-3">
        <div className="bg-[#FFF6ED] rounded-xl">
          <button
            className="w-full text-start px-4 py-3 font-medium flex items-center justify-between"
            onClick={() => handleTabClick('profile')}
          >
           {translations["edt_prfl"]||" Edit profile"} <span className="text-xl">{'>'}</span>
          </button>
        </div>
        <div className="bg-[#FFF6ED] rounded-xl">
          {navItems.slice(1, 5).map(item => (
            <button
              key={item.key}
              className="w-full text-start px-4 py-3 border-b last:border-b-0 border-[#f3e5d7] font-medium flex items-center justify-between"
              onClick={() => handleTabClick(item.key)}
            >
              {item.label} <span className="text-xl">{'>'}</span>
            </button>
          ))}
        </div>
        <div className="bg-[#FFF6ED] rounded-xl">
          {navItems.slice(5).map(item => (
            <button
              key={item.key}
              className="w-full text-start px-4 py-3 border-b last:border-b-0 border-[#f3e5d7] font-medium flex items-center justify-between"
              onClick={() => handleTabClick(item.key)}
            >
              {item.label} <span className="text-xl">{'>'}</span>
            </button>
          ))}
                      <button
              className="w-full text-start px-4 py-3 border-b last:border-b-0 border-[#f3e5d7] font-medium flex items-center justify-between"
              onClick={() => logout()}
            >
              {translations["logout"]||"Logout"}
            </button>
        </div>
      </div>
    </div>
  )
}